import axios from 'axios'

export default {
    namespaced: true,
    state: {
        categories: []
    },
    mutations: {
        FETCH_CATEGORIES(state, categories) {
            state.categories = categories
        },
        ADD_CATEGORIES(state, category) {
            state.categories.push(category)
        },
        EDIT_CATEGORIES(state, category) {
            const index = state.categories.findIndex(
                item => item.id === category.id
            )
            if (index !== -1) {
                Object.assign(state.categories[index], category)
            }
        },
        DEL_CATEGORIES(state, category) {
            const index = state.categories.findIndex(
                item => item.id === category.id
            )
            if (index !== -1) {
                state.categories.splice(index, 1)
            }
        }
    },
    actions: {
        fetch({commit, dispatch, state}, isPreload = true) {
            return new Promise((resolve, reject) => {
                if (state.categories.length) {
                    resolve()
                } else {
                    if (isPreload) {
                        commit('TOGGLE_PRELOADER', true, {root: true})
                    }
                    axios.get(
                        '/api/restaurant-manager/categories/list'
                    ).then(({data}) => {
                        commit('FETCH_CATEGORIES', data.data)
                        resolve()
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    }).finally(() => {
                        if (isPreload) {
                            commit('TOGGLE_PRELOADER', false, {root: true})
                        }
                    })
                }
            })
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/restaurant-manager/categories/add', data
                ).then(({data}) => {
                    commit('ADD_CATEGORIES', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/restaurant-manager/categories/edit/' + editedItem.id, editedItem
                ).then(({data}) => {
                    commit('EDIT_CATEGORIES', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/restaurant-manager/categories/dell/' + itemId
                ).then(({data}) => {
                    commit('DEL_CATEGORIES', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

